import axios from 'axios/index';
import { getAPIHost, getExpressAPIHost } from '../../../../utils';
import Split from '../../../split';

export const GET_QUOTA_LEASING_DETAILS = 'GET_QUOTA_LEASING_DETAILS';
export const GET_LEASE_DATA = 'GET_LEASE_DATA';

export function getQuotaLeasingDetails() {
    const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
    const host = useExpress ? getExpressAPIHost() : getAPIHost();
    const request = axios.get(`${host}/quota-leases`);

    return (dispatch) => request.then((response) => dispatch({ type: GET_QUOTA_LEASING_DETAILS, payload: response.data }));
}

export function getLeaseData(type, month, year) {
    const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
    const host = useExpress ? getExpressAPIHost() : getAPIHost();
    const request = axios.post(`${host}/quota-leases/export-report`, {
        type,
        month,
        year,
    });

    return (dispatch) => request.then((response) => dispatch({ type: GET_LEASE_DATA, payload: response.data }));
}
